import { z } from 'zod';
/** 'block' = 입력 차단(거부 문구), 'mask' = 탐지/플래그만(차단 안 함). */
export const BannedKeywordActionSchema = z.enum(['block', 'mask']);
/** 응답 스키마. */
export const BannedKeywordSchema = z.object({
    id: z.string().uuid(),
    term: z.string(),
    action: BannedKeywordActionSchema,
    enabled: z.boolean(),
    note: z.string().nullable(),
    createdAt: z.string(),
});
export const BannedKeywordListSchema = z.object({
    keywords: z.array(BannedKeywordSchema),
});
export const CreateBannedKeywordRequestSchema = z.object({
    term: z.string().min(1).max(200),
    action: BannedKeywordActionSchema.default('block'),
    enabled: z.boolean().default(true),
    note: z.string().max(500).nullable().default(null),
});
export const UpdateBannedKeywordRequestSchema = z
    .object({
    term: z.string().min(1).max(200).optional(),
    action: BannedKeywordActionSchema.optional(),
    enabled: z.boolean().optional(),
    note: z.string().max(500).nullable().optional(),
})
    .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: '하나 이상의 필드를 지정해야 합니다.',
});
//# sourceMappingURL=banned-keywords.js.map